// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./tokens.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('./Calendar.css'); */

/** VERY IMPORTANT: RWD */

body,
* {
    font-family: var(--uno-font-default);
    /* font-size: calc(0.5vh + 0.5vw); */
    margin: 0;
}

* {
    box-sizing: var(--uno-box-sizing-default);
}

/** TAG: Globals */

a {
    -webkit-text-decoration: var(--uno-anchor-decoration-default);
            text-decoration: var(--uno-anchor-decoration-default);
}

code {
    font-family: var(--uno-font-code);
}

/**   Containers     */

.container {
    font-family: var(--uno-font-container);
    margin: 0 2%;
}

.full-size-container {
    position: relative;
    width: 100%;
    height: 100%;
}

/** Positioning */

.v-center {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
}

.h-center {
    position: relative;
    left: 50%;
    height: auto;
    transform: translateX(-50%);
}

.vh-center {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.v-bottom {
    position: fixed;
    bottom: 0px;
    width: 100%;
}

.v-top {
    position: fixed;
    top: 0px;
    width: 100%;
}

.nowrap {
    white-space: nowrap;
}

.center {
    text-align: center;
}

.ellipsis {
    /** 
    width: nnU;
    */
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
    padding-bottom: 5px;
}

.right {
    text-align: right;
}

.left {
    text-align: left;
}

.position-center {
    position: relative;
    left: 50%;
    transform: translate(-50%);
}

.position-bottom {
    position: relative;
    bottom: 0%;
}

.position-right {
    position: relative;
    bottom: 0%;
}

.clearfix::after {
    clear: both;
    content: '';
    overflow: hidden;
}

.align-bottom {
    vertical-align: bottom;
}

.header {
    background-color: rgba(000, 000, 000, 0);
    min-height: 4rem;
}

.box-lower {
    border: 1px solid blue;
    border-radius: 0 20px;
    padding: 10px;
    margin: 10px;
    box-shadow: 5px 5px blue;
}

.box-upper {
    border: 1px solid blue;
    border-radius: 0 20px;
    padding: 10px;
    margin: 10px;
    box-shadow: -5px -5px blue;
}

.clickable {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: blue;
    font-size: smaller;
    border: none;
    background-color: inherit;
}

.clickable:hover {
    text-decoration: underline;
    font-weight: bolder;
    color: green;
}

.box-content {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: blue;
    background-color: white;
}

.box-content:hover {
    background-color: darkgray;
}

.box-content-active {
    -webkit-user-select: none;
            user-select: none;
    font-size: larger;
    box-shadow: 5px 5px green;
    color: white;
    background-color: blueviolet;
}

/* Dialogs */

.dialog-title {
    width: 100%;
    height: 2rem;
    padding: 3px 10px;
    border: 1px solid #D8D8D8;
    margin: 0px 0px;
    color: black;
    -webkit-user-select: none;
            user-select: none;
    background-color: #FFFFFF;
}

.dialog-title-inline {
    /* position: relative; */
    left: 0%;
    width: 100%;
    background-color: none;
}

.dialog-title-text {
    font-size: 1rem;
    font-weight: normal;
}

.dialog-content {
    overflow: visible;
}

/* Arrows */
.arrow-up,
.arrow-down,
.arrow-left,
.arrow-right {
    width: 1rem;
    height: 1rem;
    background-size: 1rem;
    content: "";
    margin: auto;
    margin-top: 3px;
    display: inline-block;
    transition: transform .2s ease-in-out;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.arrow-up:hover,
.arrow-down:hover,
.arrow-left:hover,
.arrow-right:hover {
    border: 2px dashed;
    padding: 5px;
}

.arrow-down {
    transform: rotate(-180deg);
}

.arrow-left {
    transform: rotate(90deg);
}

.arrow-right {
    transform: rotate(-90deg);
}


/* Floats */

.float-right {
    float: right;
}

.float-left {
    float: left;
}

/* Input/View Property*/
.prop-cell {
    border: '1px dashed snow';
    padding: '3px';
}

.input-label {
    color: rgba(0, 0, 0, 0.6);
    display: inline;
}

.input-description {
    color: rgba(0, 0, 0, 0.4);
    font-size: smaller;
    font-style: italic;
}

.input-field {
    /* width: 100%;*/
    /* padding: 0px 10px; */
    display: inline;
}

.input-wid {
    width: 100%;
    display: inline;
}

.no-list {
    list-style: none;
}

.screen-full {
    position: static;
    top: auto;
    left: auto;
    width: auto;
    height: auto;
    border: 1px solid black;
    z-index: inherit;
}

.screen-center {
    position: static;
    top: 0%;
    left: 0%;
    width: 0%;
    min-height: 0px;
    transform: translate(0%, 0%);
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 98%;
    height: 98%;
    background-color: lightgrey;
    border: 1px solid green;
    z-index: 5;
}

.bkg-opaque {
    background: rgba(255, 255, 255, 1.0)
}

.bkg-transparent {
    background: rgba(255, 255, 255, 0.0)
}

.bkg-translucent {
    background: rgba(255, 255, 255, 0.7)
}

.display-block {
    display: block;
}

.display-inline {
    display: inline-block;
}

.display-none {
    display: none;
}

.place-front {
    position: absolute;
    z-index: 2;
}

.place-behind {
    position: absolute;
    z-index: -2;
}

.katex-html {
    display: none;
}

.indent-10 {
    position: relative;
    left: 10px;
}

/* Entity */
.entity-prop {
    margin-bottom: 1.67rem;
}

.entity-view {
    border: var(--uno-size-0) dotted green;
    border-width: var(--uno-size-0);
    padding: var(--uno-size-0);
    border-radius: var(--uno-size-0) var(--uno-size-12);
    margin: var(--uno-size-0);
    margin-bottom: var(--uno-size-0);
    padding: var(--uno-size-0);
    background-color: inherit;
    box-shadow: var(--uno-size-0) var(--uno-size-0);
}

.entity-quickview {
    color: blue;
}

.entity-quickview:visited {
    color: blue;
}

.chip {
    display: inline-block;
    padding: 5px;
    margin: 5px;
    border: 1px solid blue;
    border-radius: 20px;
}

.message-view {
    border: var(--uno-size-2) solid blue;
    padding: var(--uno-size-4);
    border-radius: var(--uno-size-4) var(--uno-size-4);
    margin: var(--uno-size-4);
    background-color: lightgrey;
    box-shadow: var(--uno-size-0) var(--uno-size-40);
    color: blue;
}

.view-prop-name {
    font-weight: bold;
    color: blue;
}

.view-prop-value {
    font-weight: bold;
    color: blue;
}

.table {
    border-collapse: collapse;
    border: 1px solid blue;
    width: 100%;
}

.table-striped tr:nth-child(odd) {
    background-color: lightskyblue;
}

.table .action-col {
    width: 10%;
}

.app-layout {
    overflow: auto;
    height: 95vh;
}

.app-logo {
    width: 4rem;
    height: 4rem;
    float: left;
    margin: 10px;
}

.app-title {
    text-shadow: 0px 0px 0px black;
    font-size: 1.46rem;
    padding: 5px;
    color: black;
}

.app-subtitle {
    display: none;
    color: white;
    font-size: smaller;
    background-color: darkgreen;
    margin: 10px;
    padding: 5px;
}

.profile-panel {
    background-color: rgba(000, 000, 000, 0.3);
    padding: 5px;
    color: white;
    text-shadow: none;
}

.signin {
    cursor: pointer;
}

.signin-external {
    width: 100%;
    height: 100%;
}

.login-panel {
    z-index: 5;
}

/* Primary Menu */
.primary-menu {
    position: static;
    bottom: 0%;
    width: 100%;
}

/* User Profile */
.active-person {
    color: inherit;
    font-size: inherit;
    /* font-style: italic; */
    text-decoration: inherit;
}

/* Navigation Section */

.app-nav {
    position: relative;
    top: 0;
    text-align: left;
}

.app-nav-content {
    /* background-color: white; */
    position: relative;
    top: 0;
    display: inline-block;
}

.app-nav-content-admin {
    background-color: blue;
}

.app-nav-icon,
.app-nav-toggle {
    display: none;
    -webkit-user-select: none;
            user-select: none;
}

.app-nav-list {
    position: relative;
    top: 0px;
    display: flex;
    justify-items: stretch;
    flex-wrap: wrap;
    list-style-type: none;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    margin: 1px;
    background-color: #FFFFFF;
}

.app-nav-vertical {
    display: block;
    position: relative;
    left: 0px;
    margin: 1px;
}

.app-nav-horizontal {
    display: inline-block;
    vertical-align: top;
    /*min-width: 150px; */
    position: relative;
    left: 0px;
    margin: 1px;
}

.app-nav-link-toggle {
    background-color: inherit;
    border: 0px solid ;
}

.app-nav-tool {
    width: var(--uno-toolbar-icon-width);
    height: var(--uno-toolbar-icon-height);
}

.app-nav-wrapper {
    position: relative;
    margin-left: var(--uno-size-0);
}

.app-nav-link {
    color: inherit;
    padding: 5px;
    margin: var(--uno-size-0);
    white-space: nowrap;
    overflow: hidden;
    height: 100%;
    width: 100%;
    border: 0rem solid #E7ECF3;
    border-right: 1px solid #E7ECF3;
    border-bottom: 0px solid #E7ECF3;
    padding: 5px 5px;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: var(--uno-radius-0);
    box-shadow: 0px 0 black;
    text-align: left;
}

.app-nav-link-active {
    background-color: lightgray;
}

.app-nav-link-inactive {
    /* white */
    /* rgba(255, 255, 255, 1);*/
    background-color: inherit;
}

.app-nav-link:hover {
    background-color: gray;
    color: white;
}

.app-nav-link a {
    color: inherit;
}

/*
.app-nav-link a:hover {
    color: white;
}
*/

.app-nav-link-admin:hover {
    background-color: greenyellow;
}

.app-nav-link-admin a {
    color: black;
}

.app-nav-link-admin a:hover {
    background-color: green;
}

.app-nav-link-icon {
    height: 1rem;
    width: auto;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    display: inline-block;
    overflow: hidden;
    /* border-radius: 12px; */
}

.tool-icon,
.toggle {
    position: relative;
    top: var(--uno-size-5);
    height: var(--uno-size-20);
    width: var(--uno-size-20);
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    display: inline-block;
    overflow: hidden;
}

.file-img {
    width: auto;
    height: 50px;
}

.tool-icon:hover {
    padding: var(--uno-size-2);
    background-color: gray;
}

/*  Application */
.app-content {
    margin-top: 15px;
}

.app-footer {
    font-size: xx-small;
    text-align: center;
    border-top: 1px solid gray;
    background-color: rgba(000, 000, 000, 0);
}

.app-wm-contact {
    font-style: italic;
}

/*
    Carousel
*/
.caraousel {
    border: 1px solid blue;
    box-shadow: 2px 2px blue;
    padding: 0px 10px;
    margin: 10px;
}

.caraousel-item {
    margin: 10px;
}

/**  Entity Main */

.flex-container {
    display: flex;
    align-items: stretch;
    flex-wrap: wrap;
    justify-content: space-around;
}

.flex-container .flex-child {
    margin: 0px;
}

/* Data Grid / eTable */
.uno-data-grid {
    overflow: auto;
    margin-top: 10px;
}

.uno-data-grid table {
    flex: 1 1;
    display: grid;
    border-collapse: collapse;
    border-bottom: 1px solid gray;
}

.uno-data-grid thead,
.uno-data-grid tbody,
.uno-data-grid tr {
    display: contents;
}

.uno-data-grid th,
.uno-data-grid td {
    padding: 5px 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-left: 1px solid rgb(255, 255, 150);
}

.uno-data-grid th {
    background: #efeff5;
    text-align: left;
    font-weight: normal;
    font-size: 1.1rem;
    color: black;
    /* position: relative; */
    -webkit-user-select: none;
            user-select: none;
    border-top: 2px solid rgb(255, 255, 150);
    border-bottom: 2px solid rgb(255, 255, 150);
}

.uno-data-grid th:last-child,
.uno-data-grid td:last-child {
    flex: 1 1;
    border-right: 1px solid rgb(255, 255, 150);
}

.uno-data-grid .resize-handle {
    /* position: absolute; */
    top: 0;
    right: 0;
    bottom: 0;
    background: black;
    opacity: 0;
    width: 3px;
    cursor: col-resize;
}

.uno-data-grid .resize-handle:hover,
/* The following selector is needed so the handle is visible during resize even if the mouse isn't over the handle anymore */
.uno-data-grid .header--being-resized .resize-handle {
    opacity: 0.5;
}

.uno-data-grid th:hover .resize-handle {
    opacity: 0.3;
}

.uno-data-grid td {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #808080;
}

.uno-data-grid tr:nth-child(even) td {
    background: #f8f6ff;
}

/*
.uno-data-grid table td,
.uno-data-grid table th {
    padding: 0px 15px;
    border: 1px solid black;
}

.uno-data-grid table tbody tr:nth-child(even) {
    background-color: lightgray;
}

.uno-data-grid table thead {
    background-color: gray;
    color: white;
    word-wrap: none;
    padding: 10px;
    user-select: none;
}

.uno-data-grid table tr td:first-child {
    word-wrap: none;
}
*/

/*
Uno Button Comp
*/
.uno-button {
    cursor: pointer;

    /* user-select: none; */
    a {
        color: inherit;
    }

    a:hover {
        color: inherit;
    }

    a:visited {
        color: inherit;
    }
}

.uno-button-navigate {
    background: none;
    border: none;
}

.image-button {
    border: none;
    padding: 0px;
    margin: 0px;
    background: none;
}

.image-fill {
    width: 100%;
    height: auto;
    object-fit: contain;
}


.scroller {
    border: 1px solid gray;
    border-radius: 5px;
    min-height: 200px;
    margin: 5px;
    padding: 10px;
    font-size: 20px;
    font-weight: 600;
}

.scroller:hover {
    font-size: larger;
    font-weight: bolder;
    border-width: 3px;
    box-shadow: 4px 4px 4px gray;
}

/* The animation code */
@keyframes grayscale {
    from {
        filter: grayscale(100%);
    }

    to {
        filter: grayscale(0%);
    }
}

@keyframes fadeIn {
    0% {
        position: relative;
        left: 100vw;
    }

    30% {
        position: relative;
        left: 100vw;
    }

    100% {
        position: relative;
        left: 0;
    }

}

/* The animation code */
@keyframes zoom-in {
    from {
        width: 0%;
        height: 0%;
    }

    to {
        width: 100%;
        height: 100%;
    }
}

.animate {
    animation-name: fadeIn;
    animation-duration: 4s;
}

.caraousel-item-active {
    display: block;
}


.caraousel-item-inactive {
    display: none;
}

.caraousel-nav {
    margin: 10px;
    padding: 5px;
}

.caraousel-nav-item {
    border: 2px green solid;
    border-radius: 15px;
    box-shadow: 2px 2px blue;
    width: 30px;
    height: 30px;
    -webkit-user-select: none;
            user-select: none;
    margin: 10px;
    /* padding: 5px; */
    cursor: pointer;
}

/* Designer  */
.designer-canvas {
    position: relative;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 100%;
    overflow: auto;
}

.designer-section {
    position: relative;
    top: 0%;
    left: 0%;
    width: 99%;
    height: 99%;
    border-left: 1px dashed black;
    border-top: 1px dashed black;
    box-shadow: 2px 2px black;
    background-color: white;
    overflow: auto;
}

.designer-drag-over {
    border: 2px dashed gray;
    background-color: lightgray;
}

.designer-active-content {
    border: 2px solid blue;
}

.designer-faded {
    filter: opacity(50%);
}

.designer-palette-tool {
    margin: var(--uno-palette-margin);
    border-radius: var(--uno-palette-margin);
    box-shadow: var(--uno-palette-margin) var(--uno-palette-margin) grey;
    border: 1px solid black;
    background-color: lightgrey;
    cursor: pointer;
}

/* Select Box Styles */
.select-box {
    position: static;
    top: 0;
    margin-right: 5px;
    margin-left: 5px;
    display: inline-block;
}

.select-box-content {
    background-color: lightgray;
    position: relative;
    z-index: auto;
}

.select-box-icon {
    display: none;
    background-color: white;
    border: 1px solid blue;
    -webkit-user-select: none;
            user-select: none;
}

.select-box-list {
    position: relative;
    top: 0px;
    list-style-type: none;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    margin: 1px;
}

.select-box-vertical {
    display: block;
    position: relative;
    left: 10px;
}

.select-box-horizontal {
    display: inline-block;
    vertical-align: top;
    /*min-width: 150px;*/
    position: relative;
    left: 10px;
}

.select-box-link {
    font-size: smaller;
    color: black;
    padding: 5px;
    margin: var(--uno-size-0);
    white-space: nowrap;
    overflow: hidden;
    height: 100%;
    width: 99%;
    box-shadow: 2px 2px blue;
    text-align: left;
}

.select-box-link-active {
    color: white;
    background-color: gray;
}

.select-box-link-inactive {
    color: black;
    background-color: lightgray;
}

.select-box-link:hover {
    color: black;
    background-color: gray;
}

.select-box-link a {
    color: black;
}

.select-box-link a:hover {
    color: white;
}

/* Typeahead Styles */

.typeahead {
    position: static;
    top: 0;
}

.typeahead-content {
    background-color: aliceblue;
    position: relative;
    z-index: 1;
}

.typeahead-icon {
    display: none;
    background-color: white;
    border: 1px solid blue;
    -webkit-user-select: none;
            user-select: none;
}

.typeahead-list {
    position: relative;
    top: 0px;
    list-style-type: none;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    margin: 1px;
}

.typeahead-vertical {
    display: block;
    position: relative;
    left: 10px;
}

.typeahead-horizontal {
    display: inline-block;
    vertical-align: top;
    /* min-width: 150px; */
    position: relative;
    left: 10px;
}

.typeahead-link {
    font-size: smaller;
    color: black;
    padding: 5px;
    margin: 2px;
    white-space: nowrap;
    overflow: hidden;
    height: 100%;
    width: 99%;
    border-bottom: 1px solid greay;
    box-shadow: 0px 0px blue;
}

.typeahead-link-active {
    background-color: blue;
}

.typeahead-link-inactive {
    background-color: inherit;
}

.typeahead-link:hover {
    color: white;
    background-color: lightblue;
}

.typeahead-link a {
    color: black;
}

.typeahead-link a:hover {
    color: white;
}

/* Style the tab */
.tab {
    overflow: hidden;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
}

/* Style the link inside the tab */
.tab-nav {
    border: none;
    outline: none;
    cursor: pointer;
    padding: 5px 16px;
    transition: 0.3s;
    font-size: 12px;
}

/* Change background color of buttons on hover */
.tab-nav:hover {
    background-color: #ddd;
}

/* Create an active/current tablink class */
.active-tab {
    background-color: #aaa;
    font-weight: bold;
    color: white;
}

/* Style the tab content */
.tabcontent {
    padding: 0px 0px;
    animation: fadeEffect 1s;
    border: 1px solid #ccc;
}

/* Fade in tabs */

@keyframes fadeEffect {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Orientation */
.tab-horizontal {
    display: inline-block;
}

.tab-vertical {
    display: block;
}

/* Message Entity    */
.msg-sender,
.msg-time {
    font-size: smaller;
    color: darkblue;
}

.msg-text {
    margin: 5px;
    padding: 5px;
    color: blue;
}

@keyframes zoom_zoom {
    from {
        background-color: red;
    }

    to {
        background-color: yellow;
    }
}

.animate-reader {
    animation-duration: 4s;
    animation-name: zoom_zoom;
    animation-iteration-count: infinite;
}

/*     Uno Sheet */

.sheet-cell {
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    min-width: 100px;
    min-height: 25px;
    overflow: hidden;
}

.sheet-header {
    background-color: lightgray;
    white-space: nowrap;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    color: blue;
}

/*  
    box model 
    */
.row {
    width: 100%;
}

.row::after {
    content: "";
    clear: both;
    display: table;
}

[class*="col-"] {
    float: left;
    padding: 0px 5px;
}

/* Mobile First */
[class*="col-"] {
    width: 100%;
}

/* Different larger Screen sizes*/
@media (min-width: 600px) {
    .app-title {
        display: block;
        /* color: black; */
    }

    .app-subtitle {
        display: block;
    }

    .app-content {
        margin: 0px;
    }

    /* Navigations */

    .app-nav-icon {
        display: none;
    }

    /* For tablets: */
    .col-s-1 {
        width: 8.33%;
    }

    .col-s-2 {
        width: 16.66%;
    }

    .col-s-3 {
        width: 25%;
    }

    .col-s-4 {
        width: 33.33%;
    }

    .col-s-5 {
        width: 41.66%;
    }

    .col-s-6 {
        width: 50%;
    }

    .col-s-7 {
        width: 58.33%;
    }

    .col-s-8 {
        width: 66.66%;
    }

    .col-s-9 {
        width: 75%;
    }

    .col-s-10 {
        width: 83.33%;
    }

    .col-s-11 {
        width: 91.66%;
    }

    .col-s-12 {
        width: 100%;
    }
}

@media (min-width: 768px) {
    /* Primary Menu*/

    .primary-menu {
        position: static;
    }

    /* For desktop: */
    .col-1 {
        width: 8.33%;
    }

    .col-2 {
        width: 16.66%;
    }

    .col-3 {
        width: 25%;
    }

    .col-4 {
        width: 33.33%;
    }

    .col-5 {
        width: 41.66%;
    }

    .col-6 {
        width: 50%;
    }

    .col-7 {
        width: 58.33%;
    }

    .col-8 {
        width: 66.66%;
    }

    .col-9 {
        width: 75%;
    }

    .col-10 {
        width: 83.33%;
    }

    .col-11 {
        width: 91.66%;
    }

    .col-12 {
        width: 100%;
    }
}

@media only print {

    .app-nav-content,
    .uno-button,
    .tool-icon {
        display: none;
    }

    .noprint {
        display: none;
    }

}`, "",{"version":3,"sources":["webpack://./src/@uno/styles/uno-styles.css"],"names":[],"mappings":"AAEA,mCAAmC;;AAEnC,yBAAyB;;AAEzB;;IAEI,oCAAoC;IACpC,oCAAoC;IACpC,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,kBAAkB;;AAElB;IACI,6DAAqD;YAArD,qDAAqD;AACzD;;AAEA;IACI,iCAAiC;AACrC;;AAEA,sBAAsB;;AAEtB;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,QAAQ;IAER,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IAEZ,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IAET,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;;KAEC;IACD,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;AAChC;;AAEA,YAAY;;AAEZ;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,QAAQ;IACR,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,WAAW;AACX;;;;IAII,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,qCAAqC;IACrC,yDAAiS;IACjS,4BAA4B;IAC5B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;;;IAII,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,WAAW;;AAEX;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IAEf,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,WAAW;AACX;IACI,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;IAC/B,0BAA0B;IAC1B,mDAAmD;IACnD,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;IAC1B,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,kDAAkD;IAClD,yBAAyB;IACzB,2BAA2B;IAC3B,gDAAgD;IAChD,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA,uBAAuB;;AAEvB;IACI,kBAAkB;IAClB,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,MAAM;IACN,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,+BAA+B;IAC/B,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;CAIC;;AAED;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;CAEC;AACD;IACI,sBAAsB;IACtB,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,kBAAkB;;AAElB;IACI,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA,uBAAuB;AACvB;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;IACxB,yBAAiB;YAAjB,iBAAiB;IACjB,wCAAwC;IACxC,2CAA2C;AAC/C;;AAEA;;IAEI,SAAO;IACP,0CAA0C;AAC9C;;AAEA;IACI,wBAAwB;IACxB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,UAAU;IACV,kBAAkB;AACtB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC;;AAED;;CAEC;AACD;IACI,eAAe;;IAEf,uBAAuB;IACvB;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA,uBAAuB;AACvB;IACI;QAEI,uBAAuB;IAC3B;;IAEA;QAEI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,OAAO;IACX;;AAEJ;;AAEA,uBAAuB;AACvB;IACI;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,wCAAwC;IACxC,oEAAoE;IACpE,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,qBAAqB;;AAErB;IACI,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gDAAgD;AAChD;IACI,sBAAsB;AAC1B;;AAEA,2CAA2C;AAC3C;IACI,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAEhB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA,iBAAiB;;AAWjB;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;;IAEI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA,kBAAkB;;AAElB;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;;KAEK;AACL;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,WAAW;AACf;;AAEA,iCAAiC;AACjC;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA,gBAAgB;;IAEhB;QACI,aAAa;IACjB;;IAEA,iBAAiB;IACjB;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;;IAEhB;QACI,gBAAgB;IACpB;;IAEA,iBAAiB;IACjB;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;;IAEI;;;QAGI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;AAEJ","sourcesContent":["@import url('./tokens.css');\n\n/* @import url('./Calendar.css'); */\n\n/** VERY IMPORTANT: RWD */\n\nbody,\n* {\n    font-family: var(--uno-font-default);\n    /* font-size: calc(0.5vh + 0.5vw); */\n    margin: 0;\n}\n\n* {\n    box-sizing: var(--uno-box-sizing-default);\n}\n\n/** TAG: Globals */\n\na {\n    text-decoration: var(--uno-anchor-decoration-default);\n}\n\ncode {\n    font-family: var(--uno-font-code);\n}\n\n/**   Containers     */\n\n.container {\n    font-family: var(--uno-font-container);\n    margin: 0 2%;\n}\n\n.full-size-container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n/** Positioning */\n\n.v-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.h-center {\n    position: relative;\n    left: 50%;\n    height: auto;\n    -ms-transform: translateX(-50%);\n    transform: translateX(-50%);\n}\n\n.vh-center {\n    position: relative;\n    top: 50%;\n    left: 50%;\n    -ms-transform: translateX(-50%) translateY(-50%);\n    transform: translateX(-50%) translateY(-50%);\n}\n\n.v-bottom {\n    position: fixed;\n    bottom: 0px;\n    width: 100%;\n}\n\n.v-top {\n    position: fixed;\n    top: 0px;\n    width: 100%;\n}\n\n.nowrap {\n    white-space: nowrap;\n}\n\n.center {\n    text-align: center;\n}\n\n.ellipsis {\n    /** \n    width: nnU;\n    */\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: left;\n    padding-bottom: 5px;\n}\n\n.right {\n    text-align: right;\n}\n\n.left {\n    text-align: left;\n}\n\n.position-center {\n    position: relative;\n    left: 50%;\n    transform: translate(-50%);\n}\n\n.position-bottom {\n    position: relative;\n    bottom: 0%;\n}\n\n.position-right {\n    position: relative;\n    bottom: 0%;\n}\n\n.clearfix::after {\n    clear: both;\n    content: '';\n    overflow: hidden;\n}\n\n.align-bottom {\n    vertical-align: bottom;\n}\n\n.header {\n    background-color: rgba(000, 000, 000, 0);\n    min-height: 4rem;\n}\n\n.box-lower {\n    border: 1px solid blue;\n    border-radius: 0 20px;\n    padding: 10px;\n    margin: 10px;\n    box-shadow: 5px 5px blue;\n}\n\n.box-upper {\n    border: 1px solid blue;\n    border-radius: 0 20px;\n    padding: 10px;\n    margin: 10px;\n    box-shadow: -5px -5px blue;\n}\n\n.clickable {\n    cursor: pointer;\n    user-select: none;\n    color: blue;\n    font-size: smaller;\n    border: none;\n    background-color: inherit;\n}\n\n.clickable:hover {\n    text-decoration: underline;\n    font-weight: bolder;\n    color: green;\n}\n\n.box-content {\n    cursor: pointer;\n    user-select: none;\n    color: blue;\n    background-color: white;\n}\n\n.box-content:hover {\n    background-color: darkgray;\n}\n\n.box-content-active {\n    user-select: none;\n    font-size: larger;\n    box-shadow: 5px 5px green;\n    color: white;\n    background-color: blueviolet;\n}\n\n/* Dialogs */\n\n.dialog-title {\n    width: 100%;\n    height: 2rem;\n    padding: 3px 10px;\n    border: 1px solid #D8D8D8;\n    margin: 0px 0px;\n    color: black;\n    user-select: none;\n    background-color: #FFFFFF;\n}\n\n.dialog-title-inline {\n    /* position: relative; */\n    left: 0%;\n    width: 100%;\n    background-color: none;\n}\n\n.dialog-title-text {\n    font-size: 1rem;\n    font-weight: normal;\n}\n\n.dialog-content {\n    overflow: visible;\n}\n\n/* Arrows */\n.arrow-up,\n.arrow-down,\n.arrow-left,\n.arrow-right {\n    width: 1rem;\n    height: 1rem;\n    background-size: 1rem;\n    content: \"\";\n    margin: auto;\n    margin-top: 3px;\n    display: inline-block;\n    transition: transform .2s ease-in-out;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    cursor: pointer;\n    user-select: none;\n}\n\n.arrow-up:hover,\n.arrow-down:hover,\n.arrow-left:hover,\n.arrow-right:hover {\n    border: 2px dashed;\n    padding: 5px;\n}\n\n.arrow-down {\n    transform: rotate(-180deg);\n}\n\n.arrow-left {\n    transform: rotate(90deg);\n}\n\n.arrow-right {\n    transform: rotate(-90deg);\n}\n\n\n/* Floats */\n\n.float-right {\n    float: right;\n}\n\n.float-left {\n    float: left;\n}\n\n/* Input/View Property*/\n.prop-cell {\n    border: '1px dashed snow';\n    padding: '3px';\n}\n\n.input-label {\n    color: rgba(0, 0, 0, 0.6);\n    display: inline;\n}\n\n.input-description {\n    color: rgba(0, 0, 0, 0.4);\n    font-size: smaller;\n    font-style: italic;\n}\n\n.input-field {\n    /* width: 100%;*/\n    /* padding: 0px 10px; */\n    display: inline;\n}\n\n.input-wid {\n    width: 100%;\n    display: inline;\n}\n\n.no-list {\n    list-style: none;\n}\n\n.screen-full {\n    position: static;\n    top: auto;\n    left: auto;\n    width: auto;\n    height: auto;\n    border: 1px solid black;\n    z-index: inherit;\n}\n\n.screen-center {\n    position: static;\n    top: 0%;\n    left: 0%;\n    width: 0%;\n    min-height: 0px;\n    -ms-transform: translate(0%, 0%);\n    transform: translate(0%, 0%);\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 98%;\n    height: 98%;\n    background-color: lightgrey;\n    border: 1px solid green;\n    z-index: 5;\n}\n\n.bkg-opaque {\n    background: rgba(255, 255, 255, 1.0)\n}\n\n.bkg-transparent {\n    background: rgba(255, 255, 255, 0.0)\n}\n\n.bkg-translucent {\n    background: rgba(255, 255, 255, 0.7)\n}\n\n.display-block {\n    display: block;\n}\n\n.display-inline {\n    display: inline-block;\n}\n\n.display-none {\n    display: none;\n}\n\n.place-front {\n    position: absolute;\n    z-index: 2;\n}\n\n.place-behind {\n    position: absolute;\n    z-index: -2;\n}\n\n.katex-html {\n    display: none;\n}\n\n.indent-10 {\n    position: relative;\n    left: 10px;\n}\n\n/* Entity */\n.entity-prop {\n    margin-bottom: 1.67rem;\n}\n\n.entity-view {\n    border: var(--uno-size-0) dotted green;\n    border-width: var(--uno-size-0);\n    padding: var(--uno-size-0);\n    border-radius: var(--uno-size-0) var(--uno-size-12);\n    margin: var(--uno-size-0);\n    margin-bottom: var(--uno-size-0);\n    padding: var(--uno-size-0);\n    background-color: inherit;\n    box-shadow: var(--uno-size-0) var(--uno-size-0);\n}\n\n.entity-quickview {\n    color: blue;\n}\n\n.entity-quickview:visited {\n    color: blue;\n}\n\n.chip {\n    display: inline-block;\n    padding: 5px;\n    margin: 5px;\n    border: 1px solid blue;\n    border-radius: 20px;\n}\n\n.message-view {\n    border: var(--uno-size-2) solid blue;\n    padding: var(--uno-size-4);\n    border-radius: var(--uno-size-4) var(--uno-size-4);\n    margin: var(--uno-size-4);\n    background-color: lightgrey;\n    box-shadow: var(--uno-size-0) var(--uno-size-40);\n    color: blue;\n}\n\n.view-prop-name {\n    font-weight: bold;\n    color: blue;\n}\n\n.view-prop-value {\n    font-weight: bold;\n    color: blue;\n}\n\n.table {\n    border-collapse: collapse;\n    border: 1px solid blue;\n    width: 100%;\n}\n\n.table-striped tr:nth-child(odd) {\n    background-color: lightskyblue;\n}\n\n.table .action-col {\n    width: 10%;\n}\n\n.app-layout {\n    overflow: auto;\n    height: 95vh;\n}\n\n.app-logo {\n    width: 4rem;\n    height: 4rem;\n    float: left;\n    margin: 10px;\n}\n\n.app-title {\n    text-shadow: 0px 0px 0px black;\n    font-size: 1.46rem;\n    padding: 5px;\n    color: black;\n}\n\n.app-subtitle {\n    display: none;\n    color: white;\n    font-size: smaller;\n    background-color: darkgreen;\n    margin: 10px;\n    padding: 5px;\n}\n\n.profile-panel {\n    background-color: rgba(000, 000, 000, 0.3);\n    padding: 5px;\n    color: white;\n    text-shadow: none;\n}\n\n.signin {\n    cursor: pointer;\n}\n\n.signin-external {\n    width: 100%;\n    height: 100%;\n}\n\n.login-panel {\n    z-index: 5;\n}\n\n/* Primary Menu */\n.primary-menu {\n    position: static;\n    bottom: 0%;\n    width: 100%;\n}\n\n/* User Profile */\n.active-person {\n    color: inherit;\n    font-size: inherit;\n    /* font-style: italic; */\n    text-decoration: inherit;\n}\n\n/* Navigation Section */\n\n.app-nav {\n    position: relative;\n    top: 0;\n    text-align: left;\n}\n\n.app-nav-content {\n    /* background-color: white; */\n    position: relative;\n    top: 0;\n    display: inline-block;\n}\n\n.app-nav-content-admin {\n    background-color: blue;\n}\n\n.app-nav-icon,\n.app-nav-toggle {\n    display: none;\n    user-select: none;\n}\n\n.app-nav-list {\n    position: relative;\n    top: 0px;\n    display: flex;\n    justify-items: stretch;\n    flex-wrap: wrap;\n    list-style-type: none;\n    user-select: none;\n    cursor: pointer;\n    margin: 1px;\n    background-color: #FFFFFF;\n}\n\n.app-nav-vertical {\n    display: block;\n    position: relative;\n    left: 0px;\n    margin: 1px;\n}\n\n.app-nav-horizontal {\n    display: inline-block;\n    vertical-align: top;\n    /*min-width: 150px; */\n    position: relative;\n    left: 0px;\n    margin: 1px;\n}\n\n.app-nav-link-toggle {\n    background-color: inherit;\n    border: 0px solid ;\n}\n\n.app-nav-tool {\n    width: var(--uno-toolbar-icon-width);\n    height: var(--uno-toolbar-icon-height);\n}\n\n.app-nav-wrapper {\n    position: relative;\n    margin-left: var(--uno-size-0);\n}\n\n.app-nav-link {\n    color: inherit;\n    padding: 5px;\n    margin: var(--uno-size-0);\n    white-space: nowrap;\n    overflow: hidden;\n    height: 100%;\n    width: 100%;\n    border: 0rem solid #E7ECF3;\n    border-right: 1px solid #E7ECF3;\n    border-bottom: 0px solid #E7ECF3;\n    padding: 5px 5px;\n    margin-right: 5px;\n    margin-bottom: 5px;\n    border-radius: var(--uno-radius-0);\n    box-shadow: 0px 0 black;\n    text-align: left;\n}\n\n.app-nav-link-active {\n    background-color: lightgray;\n}\n\n.app-nav-link-inactive {\n    /* white */\n    /* rgba(255, 255, 255, 1);*/\n    background-color: inherit;\n}\n\n.app-nav-link:hover {\n    background-color: gray;\n    color: white;\n}\n\n.app-nav-link a {\n    color: inherit;\n}\n\n/*\n.app-nav-link a:hover {\n    color: white;\n}\n*/\n\n.app-nav-link-admin:hover {\n    background-color: greenyellow;\n}\n\n.app-nav-link-admin a {\n    color: black;\n}\n\n.app-nav-link-admin a:hover {\n    background-color: green;\n}\n\n.app-nav-link-icon {\n    height: 1rem;\n    width: auto;\n    cursor: pointer;\n    user-select: none;\n    display: inline-block;\n    overflow: hidden;\n    /* border-radius: 12px; */\n}\n\n.tool-icon,\n.toggle {\n    position: relative;\n    top: var(--uno-size-5);\n    height: var(--uno-size-20);\n    width: var(--uno-size-20);\n    cursor: pointer;\n    user-select: none;\n    display: inline-block;\n    overflow: hidden;\n}\n\n.file-img {\n    width: auto;\n    height: 50px;\n}\n\n.tool-icon:hover {\n    padding: var(--uno-size-2);\n    background-color: gray;\n}\n\n/*  Application */\n.app-content {\n    margin-top: 15px;\n}\n\n.app-footer {\n    font-size: xx-small;\n    text-align: center;\n    border-top: 1px solid gray;\n    background-color: rgba(000, 000, 000, 0);\n}\n\n.app-wm-contact {\n    font-style: italic;\n}\n\n/*\n    Carousel\n*/\n.caraousel {\n    border: 1px solid blue;\n    box-shadow: 2px 2px blue;\n    padding: 0px 10px;\n    margin: 10px;\n}\n\n.caraousel-item {\n    margin: 10px;\n}\n\n/**  Entity Main */\n\n.flex-container {\n    display: flex;\n    align-items: stretch;\n    flex-wrap: wrap;\n    justify-content: space-around;\n}\n\n.flex-container .flex-child {\n    margin: 0px;\n}\n\n/* Data Grid / eTable */\n.uno-data-grid {\n    overflow: auto;\n    margin-top: 10px;\n}\n\n.uno-data-grid table {\n    flex: 1;\n    display: grid;\n    border-collapse: collapse;\n    border-bottom: 1px solid gray;\n}\n\n.uno-data-grid thead,\n.uno-data-grid tbody,\n.uno-data-grid tr {\n    display: contents;\n}\n\n.uno-data-grid th,\n.uno-data-grid td {\n    padding: 5px 5px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    border-left: 1px solid rgb(255, 255, 150);\n}\n\n.uno-data-grid th {\n    background: #efeff5;\n    text-align: left;\n    font-weight: normal;\n    font-size: 1.1rem;\n    color: black;\n    /* position: relative; */\n    user-select: none;\n    border-top: 2px solid rgb(255, 255, 150);\n    border-bottom: 2px solid rgb(255, 255, 150);\n}\n\n.uno-data-grid th:last-child,\n.uno-data-grid td:last-child {\n    flex: 1;\n    border-right: 1px solid rgb(255, 255, 150);\n}\n\n.uno-data-grid .resize-handle {\n    /* position: absolute; */\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: black;\n    opacity: 0;\n    width: 3px;\n    cursor: col-resize;\n}\n\n.uno-data-grid .resize-handle:hover,\n/* The following selector is needed so the handle is visible during resize even if the mouse isn't over the handle anymore */\n.uno-data-grid .header--being-resized .resize-handle {\n    opacity: 0.5;\n}\n\n.uno-data-grid th:hover .resize-handle {\n    opacity: 0.3;\n}\n\n.uno-data-grid td {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    color: #808080;\n}\n\n.uno-data-grid tr:nth-child(even) td {\n    background: #f8f6ff;\n}\n\n/*\n.uno-data-grid table td,\n.uno-data-grid table th {\n    padding: 0px 15px;\n    border: 1px solid black;\n}\n\n.uno-data-grid table tbody tr:nth-child(even) {\n    background-color: lightgray;\n}\n\n.uno-data-grid table thead {\n    background-color: gray;\n    color: white;\n    word-wrap: none;\n    padding: 10px;\n    user-select: none;\n}\n\n.uno-data-grid table tr td:first-child {\n    word-wrap: none;\n}\n*/\n\n/*\nUno Button Comp\n*/\n.uno-button {\n    cursor: pointer;\n\n    /* user-select: none; */\n    a {\n        color: inherit;\n    }\n\n    a:hover {\n        color: inherit;\n    }\n\n    a:visited {\n        color: inherit;\n    }\n}\n\n.uno-button-navigate {\n    background: none;\n    border: none;\n}\n\n.image-button {\n    border: none;\n    padding: 0px;\n    margin: 0px;\n    background: none;\n}\n\n.image-fill {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n.scroller {\n    border: 1px solid gray;\n    border-radius: 5px;\n    min-height: 200px;\n    margin: 5px;\n    padding: 10px;\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.scroller:hover {\n    font-size: larger;\n    font-weight: bolder;\n    border-width: 3px;\n    box-shadow: 4px 4px 4px gray;\n}\n\n/* The animation code */\n@keyframes grayscale {\n    from {\n        -webkit-filter: grayscale(100%);\n        filter: grayscale(100%);\n    }\n\n    to {\n        -webkit-filter: grayscale(0%);\n        filter: grayscale(0%);\n    }\n}\n\n@keyframes fadeIn {\n    0% {\n        position: relative;\n        left: 100vw;\n    }\n\n    30% {\n        position: relative;\n        left: 100vw;\n    }\n\n    100% {\n        position: relative;\n        left: 0;\n    }\n\n}\n\n/* The animation code */\n@keyframes zoom-in {\n    from {\n        width: 0%;\n        height: 0%;\n    }\n\n    to {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n.animate {\n    animation-name: fadeIn;\n    animation-duration: 4s;\n}\n\n.caraousel-item-active {\n    display: block;\n}\n\n\n.caraousel-item-inactive {\n    display: none;\n}\n\n.caraousel-nav {\n    margin: 10px;\n    padding: 5px;\n}\n\n.caraousel-nav-item {\n    border: 2px green solid;\n    border-radius: 15px;\n    box-shadow: 2px 2px blue;\n    width: 30px;\n    height: 30px;\n    user-select: none;\n    margin: 10px;\n    /* padding: 5px; */\n    cursor: pointer;\n}\n\n/* Designer  */\n.designer-canvas {\n    position: relative;\n    top: 0%;\n    left: 0%;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n}\n\n.designer-section {\n    position: relative;\n    top: 0%;\n    left: 0%;\n    width: 99%;\n    height: 99%;\n    border-left: 1px dashed black;\n    border-top: 1px dashed black;\n    box-shadow: 2px 2px black;\n    background-color: white;\n    overflow: auto;\n}\n\n.designer-drag-over {\n    border: 2px dashed gray;\n    background-color: lightgray;\n}\n\n.designer-active-content {\n    border: 2px solid blue;\n}\n\n.designer-faded {\n    filter: opacity(50%);\n}\n\n.designer-palette-tool {\n    margin: var(--uno-palette-margin);\n    border-radius: var(--uno-palette-margin);\n    box-shadow: var(--uno-palette-margin) var(--uno-palette-margin) grey;\n    border: 1px solid black;\n    background-color: lightgrey;\n    cursor: pointer;\n}\n\n/* Select Box Styles */\n.select-box {\n    position: static;\n    top: 0;\n    margin-right: 5px;\n    margin-left: 5px;\n    display: inline-block;\n}\n\n.select-box-content {\n    background-color: lightgray;\n    position: relative;\n    z-index: auto;\n}\n\n.select-box-icon {\n    display: none;\n    background-color: white;\n    border: 1px solid blue;\n    user-select: none;\n}\n\n.select-box-list {\n    position: relative;\n    top: 0px;\n    list-style-type: none;\n    user-select: none;\n    cursor: pointer;\n    margin: 1px;\n}\n\n.select-box-vertical {\n    display: block;\n    position: relative;\n    left: 10px;\n}\n\n.select-box-horizontal {\n    display: inline-block;\n    vertical-align: top;\n    /*min-width: 150px;*/\n    position: relative;\n    left: 10px;\n}\n\n.select-box-link {\n    font-size: smaller;\n    color: black;\n    padding: 5px;\n    margin: var(--uno-size-0);\n    white-space: nowrap;\n    overflow: hidden;\n    height: 100%;\n    width: 99%;\n    box-shadow: 2px 2px blue;\n    text-align: left;\n}\n\n.select-box-link-active {\n    color: white;\n    background-color: gray;\n}\n\n.select-box-link-inactive {\n    color: black;\n    background-color: lightgray;\n}\n\n.select-box-link:hover {\n    color: black;\n    background-color: gray;\n}\n\n.select-box-link a {\n    color: black;\n}\n\n.select-box-link a:hover {\n    color: white;\n}\n\n/* Typeahead Styles */\n\n.typeahead {\n    position: static;\n    top: 0;\n}\n\n.typeahead-content {\n    background-color: aliceblue;\n    position: relative;\n    z-index: 1;\n}\n\n.typeahead-icon {\n    display: none;\n    background-color: white;\n    border: 1px solid blue;\n    user-select: none;\n}\n\n.typeahead-list {\n    position: relative;\n    top: 0px;\n    list-style-type: none;\n    user-select: none;\n    cursor: pointer;\n    margin: 1px;\n}\n\n.typeahead-vertical {\n    display: block;\n    position: relative;\n    left: 10px;\n}\n\n.typeahead-horizontal {\n    display: inline-block;\n    vertical-align: top;\n    /* min-width: 150px; */\n    position: relative;\n    left: 10px;\n}\n\n.typeahead-link {\n    font-size: smaller;\n    color: black;\n    padding: 5px;\n    margin: 2px;\n    white-space: nowrap;\n    overflow: hidden;\n    height: 100%;\n    width: 99%;\n    border-bottom: 1px solid greay;\n    box-shadow: 0px 0px blue;\n}\n\n.typeahead-link-active {\n    background-color: blue;\n}\n\n.typeahead-link-inactive {\n    background-color: inherit;\n}\n\n.typeahead-link:hover {\n    color: white;\n    background-color: lightblue;\n}\n\n.typeahead-link a {\n    color: black;\n}\n\n.typeahead-link a:hover {\n    color: white;\n}\n\n/* Style the tab */\n.tab {\n    overflow: hidden;\n    border: 1px solid #ccc;\n    background-color: #f1f1f1;\n}\n\n/* Style the link inside the tab */\n.tab-nav {\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 5px 16px;\n    transition: 0.3s;\n    font-size: 12px;\n}\n\n/* Change background color of buttons on hover */\n.tab-nav:hover {\n    background-color: #ddd;\n}\n\n/* Create an active/current tablink class */\n.active-tab {\n    background-color: #aaa;\n    font-weight: bold;\n    color: white;\n}\n\n/* Style the tab content */\n.tabcontent {\n    padding: 0px 0px;\n    -webkit-animation: fadeEffect 1s;\n    animation: fadeEffect 1s;\n    border: 1px solid #ccc;\n}\n\n/* Fade in tabs */\n@-webkit-keyframes fadeEffect {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeEffect {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* Orientation */\n.tab-horizontal {\n    display: inline-block;\n}\n\n.tab-vertical {\n    display: block;\n}\n\n/* Message Entity    */\n.msg-sender,\n.msg-time {\n    font-size: smaller;\n    color: darkblue;\n}\n\n.msg-text {\n    margin: 5px;\n    padding: 5px;\n    color: blue;\n}\n\n@keyframes zoom_zoom {\n    from {\n        background-color: red;\n    }\n\n    to {\n        background-color: yellow;\n    }\n}\n\n.animate-reader {\n    animation-duration: 4s;\n    animation-name: zoom_zoom;\n    animation-iteration-count: infinite;\n}\n\n/*     Uno Sheet */\n\n.sheet-cell {\n    border-right: 1px solid black;\n    border-bottom: 1px solid black;\n    min-width: 100px;\n    min-height: 25px;\n    overflow: hidden;\n}\n\n.sheet-header {\n    background-color: lightgray;\n    white-space: nowrap;\n    user-select: none;\n    cursor: pointer;\n    color: blue;\n}\n\n/*  \n    box model \n    */\n.row {\n    width: 100%;\n}\n\n.row::after {\n    content: \"\";\n    clear: both;\n    display: table;\n}\n\n[class*=\"col-\"] {\n    float: left;\n    padding: 0px 5px;\n}\n\n/* Mobile First */\n[class*=\"col-\"] {\n    width: 100%;\n}\n\n/* Different larger Screen sizes*/\n@media (min-width: 600px) {\n    .app-title {\n        display: block;\n        /* color: black; */\n    }\n\n    .app-subtitle {\n        display: block;\n    }\n\n    .app-content {\n        margin: 0px;\n    }\n\n    /* Navigations */\n\n    .app-nav-icon {\n        display: none;\n    }\n\n    /* For tablets: */\n    .col-s-1 {\n        width: 8.33%;\n    }\n\n    .col-s-2 {\n        width: 16.66%;\n    }\n\n    .col-s-3 {\n        width: 25%;\n    }\n\n    .col-s-4 {\n        width: 33.33%;\n    }\n\n    .col-s-5 {\n        width: 41.66%;\n    }\n\n    .col-s-6 {\n        width: 50%;\n    }\n\n    .col-s-7 {\n        width: 58.33%;\n    }\n\n    .col-s-8 {\n        width: 66.66%;\n    }\n\n    .col-s-9 {\n        width: 75%;\n    }\n\n    .col-s-10 {\n        width: 83.33%;\n    }\n\n    .col-s-11 {\n        width: 91.66%;\n    }\n\n    .col-s-12 {\n        width: 100%;\n    }\n}\n\n@media (min-width: 768px) {\n    /* Primary Menu*/\n\n    .primary-menu {\n        position: static;\n    }\n\n    /* For desktop: */\n    .col-1 {\n        width: 8.33%;\n    }\n\n    .col-2 {\n        width: 16.66%;\n    }\n\n    .col-3 {\n        width: 25%;\n    }\n\n    .col-4 {\n        width: 33.33%;\n    }\n\n    .col-5 {\n        width: 41.66%;\n    }\n\n    .col-6 {\n        width: 50%;\n    }\n\n    .col-7 {\n        width: 58.33%;\n    }\n\n    .col-8 {\n        width: 66.66%;\n    }\n\n    .col-9 {\n        width: 75%;\n    }\n\n    .col-10 {\n        width: 83.33%;\n    }\n\n    .col-11 {\n        width: 91.66%;\n    }\n\n    .col-12 {\n        width: 100%;\n    }\n}\n\n@media only print {\n\n    .app-nav-content,\n    .uno-button,\n    .tool-icon {\n        display: none;\n    }\n\n    .noprint {\n        display: none;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
